export default {
  bind(el, bindings, vnode) {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(() => {
        
        el.classList.add('active')
      }, 500)
    })
  }
}


// WEBPACK FOOTER //
// ./src/js/directives/fade-in/fade-in.js